(function () {
  // When picking an option value leads to a combination with no matching
  // variant (theme shows it struck through), re-select the cheapest
  // available variant that includes the value just picked.
  // Radio names are prefixed by the theme, e.g. "{product_123}Size" or
  // "{sticky_field}Size" — the prefix scopes each picker group.
  // The theme re-renders the picker asynchronously after a selection and a
  // late render can revert a correction. Shopify section renders have no
  // platform timeout, so on a slow connection that render can land many
  // seconds after the click. The observer therefore stays armed for the
  // whole session (it no-ops when the selection is already valid) rather
  // than only for a fixed window, and a rate-limiter caps runaway loops.
  var reselecting = false;
  var lastPick = null; // { prefix, pos, value }
  var corrections = 0;
  var correctionsSince = 0;
  var moTimer = null;

  function splitName(name) {
    var m = /^(\{[^}]*\})?([\s\S]*)$/.exec(name || '');
    return { prefix: m[1] || '', option: m[2] };
  }

  function getData() {
    var el = document.querySelector('script[data-pbx-reselect-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function variantOptions(variant) {
    return [variant.option1, variant.option2, variant.option3];
  }

  function readSelected(prefix, data) {
    return data.options.map(function (name) {
      var checked = document.querySelector(
        'input[type="radio"][name="' + CSS.escape(prefix + name) + '"]:checked'
      );
      return checked ? checked.value : null;
    });
  }

  function isValid(selected, data) {
    return data.variants.some(function (v) {
      return variantOptions(v).every(function (val, i) {
        return selected[i] === null || val === null || val === selected[i];
      });
    });
  }

  function applyCorrection() {
    if (!lastPick) return;
    var data = getData();
    if (!data || !data.options || !data.variants) return;
    var selected = readSelected(lastPick.prefix, data);
    if (
      selected.every(function (v) {
        return v === null;
      })
    )
      return; // picker not in DOM
    if (isValid(selected, data)) return;

    // Safety valve so a pathological render loop can't click forever.
    var now = Date.now();
    if (now - correctionsSince > 5000) {
      correctionsSince = now;
      corrections = 0;
    }
    if (++corrections > 10) return;

    // Cheapest variant that keeps the value the user last picked.
    var candidates = data.variants.filter(function (v) {
      return variantOptions(v)[lastPick.pos] === lastPick.value;
    });
    if (!candidates.length) return;
    var available = candidates.filter(function (v) {
      return v.available !== false;
    });
    var pool = available.length ? available : candidates;
    pool.sort(function (a, b) {
      return a.price - b.price;
    });
    var targetOpts = variantOptions(pool[0]);

    reselecting = true;
    try {
      data.options.forEach(function (name, i) {
        if (i === lastPick.pos || targetOpts[i] === null) return;
        if (selected[i] === targetOpts[i]) return;
        var radio = document.querySelector(
          'input[type="radio"][name="' + CSS.escape(lastPick.prefix + name) +
            '"][value="' + CSS.escape(targetOpts[i]) + '"]'
        );
        if (radio && !radio.checked) radio.click();
      });
    } finally {
      setTimeout(function () {
        reselecting = false;
      }, 0);
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (reselecting) return;
    if (!input || input.type !== 'radio') return;
    if (!input.closest('.xo-product-variant')) return;

    var data = getData();
    if (!data || !data.options || !data.variants) return;

    var parts = splitName(input.name);
    var pos = data.options.indexOf(parts.option);
    if (pos === -1) return;

    lastPick = { prefix: parts.prefix, pos: pos, value: input.value };
    setTimeout(applyCorrection, 0);
  });

  // A theme render that lands after the correction reverts it silently. The
  // observer stays armed for the session and re-validates on any DOM change;
  // it does real work only when the current selection is invalid (a cheap
  // array scan otherwise), so a late render on any connection is caught.
  if (document.body) {
    new MutationObserver(function () {
      if (!lastPick) return;
      clearTimeout(moTimer);
      moTimer = setTimeout(applyCorrection, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
